import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-slate-50 py-16 sm:py-24" aria-labelledby="testimonials-title" data-id="element-199" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-6xl px-6" data-id="element-200" data-mp="3fy2z7vpm7s3i">
        <h2 id="testimonials-title" className="text-center text-3xl font-extrabold tracking-tight text-navy-deep sm:text-4xl" data-id="element-201" data-mp="3b0ufhqotjg05">
          What Families Are Saying
        </h2>

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-202" data-mp="3205zwrjs17l5">
          {testimonials.map(testimonial => <figure key={testimonial.name} className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-7 shadow-sm" data-id="element-203" data-mp="2x09x2vmtfm76">
              <div className="flex items-center gap-0.5 text-trust" aria-hidden="true" data-id="element-204" data-mp="v9ga3nai02p5">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 fill-current" data-id="element-205" data-mp="qbevbek3upjh" />)}
              </div>
              <blockquote className="mt-4 flex-1 text-base leading-relaxed text-ink/80" data-id="element-206" data-mp="h55aw37q1xxm">
                “{testimonial.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-slate-100 pt-5" data-id="element-207" data-mp="780j9nv3xa9f">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy text-base font-bold text-white" data-id="element-208" data-mp="c6ll1rq0c1zz">
                  {testimonial.initial}
                </span>
                <span data-id="element-209" data-mp="14vj0zo6qxmpk">
                  <span className="block text-sm font-bold text-navy-deep" data-id="element-210" data-mp="14vsi0m9tcjj4">{testimonial.name}</span>
                  <span className="block text-sm text-ink/60" data-id="element-211" data-mp="q7ej2mfipf7u">{testimonial.role}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}